import { __ } from 'i18n/index';

// For staff: what the set's players keep from everyone else, as a title like
// "Hidden from public: result, characters"; null when they keep nothing.
export function hiddenFromPublicTitle(hidden) {
	if(!hidden) {
		return null;
	}
	const parts = [];
	if(hidden.history) {
		parts.push(__('the whole set'));
	}
	if(hidden.results) {
		parts.push(__('result'));
	}
	if(hidden.point_changes_of && hidden.point_changes_of.length) {
		parts.push(__('point changes'));
	}
	if(hidden.characters_of && hidden.characters_of.length) {
		parts.push(__('characters'));
	}
	return parts.length ? __('Hidden from public: %s', parts.join(', ')) : null;
}
